import ErrorBoundary from './ErrorBoundary';

export { Fallback, logError } from './ErrorBoundary';
export default ErrorBoundary;
